var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16097 14.3171H20.2201C20.5934 14.3171 20.9356 14.1092 21.1076 13.7779L24.5691 7.11127C24.9148 6.44559 24.4317 5.65045 23.6816 5.65045H7.32764",
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.6611,
    cy: 20.1,
    r: 1.5,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.6602,
    cy: 20.1,
    r: 1.5,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1.09998H4.60465C5.20155 1.09998 6.21795 1.59035 6.55814 3.36664C6.88372 5.06664 8.34884 12.6852 9.16279 16.2111C9.32558 16.8407 10.0744 18.1 11.7674 18.1C13.4605 18.1 17.2946 18.1 18 18.1",
    stroke: "#D91F05"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesActive);
export default __webpack_public_path__ + "static/media/salesActive.6250f26e33b5cafc74a50ac1a7824bbb.svg";
export { ForwardRef as ReactComponent };